import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { IssueActions } from './issue.actions';
import { IIssueState } from './issue.state';

export const initialIssueState: IIssueState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const issueReducerFn = createReducer(
  initialIssueState,
  on(IssueActions.reset, (state: IIssueState, action) => {
    return new StateBuilder<IIssueState>(initialIssueState).build();
  }),
  on(IssueActions.load, (state: IIssueState, action) => {
    return new StateBuilder<IIssueState>(state).toLoading().build();
  }),
  on(IssueActions.loadSuccess, (state: IIssueState, action) => {
    return new StateBuilder<IIssueState>(state, action).toLoaded().build();
  }),
  on(IssueActions.submit, (state: IIssueState, action) => {
    return new StateBuilder<IIssueState>(state).toLoading().build();
  }),
  on(IssueActions.submitSuccess, (state: IIssueState, action) => {
    return new StateBuilder<IIssueState>(state, action).toLoaded().build();
  }),
  on(IssueActions.saveScreenName, (state: IIssueState, { screenName }) => {
    return new StateBuilder<IIssueState>(state, { data: { ...state.data, screenName } }).build();
  })
);

export function issueReducer(state: IIssueState | undefined, action: Action) {
  return issueReducerFn(state, action);
}
